export const moduleName = "menus";

export type MenusState = {
	openMenuId: string | null;
};
